import { useFrame, useThree } from "@react-three/fiber";
import { useRef } from "react";
import { Group } from "three";
import { projects } from "../../../data/projects";
import { getViewportTier, isCompactViewport } from "../../../lib/viewport";
import { ProjectCarousel3D } from "./ProjectCarousel3D";
import { ContactShadows } from "@react-three/drei";


type ProjectsSceneProps = {
  reducedMotion: boolean;
  rotationProgress: number;
  transitionProgress: number;
  transitioningFromStudio: boolean;
  weight: number;
};

export function ProjectsScene({ rotationProgress, transitionProgress, transitioningFromStudio, weight }: ProjectsSceneProps) {
  const groupRef = useRef<Group>(null);
  const orbitAnchorRef = useRef<Group>(null);
  const viewport = useThree((state) => getViewportTier(state.size.width));
  const compact = isCompactViewport(viewport);

  useFrame((_, delta) => {
    if (!groupRef.current) {
      return;
    }

    const emergence = transitioningFromStudio ? Math.min(Math.max((transitionProgress - 0.52) / 0.48, 0), 1) : 1;
    const targetY = compact ? 0.08 : -0.06;
    const targetZ = transitioningFromStudio ? -0.88 + (1 - emergence) * -1.9 : compact ? -0.52 : -0.88;
    const targetX = compact ? 0 : 1.12;

    groupRef.current.position.x += (targetX - groupRef.current.position.x) * (1 - Math.exp(-delta * 2.8));
    groupRef.current.position.y += (targetY - groupRef.current.position.y) * (1 - Math.exp(-delta * 2.8));
    groupRef.current.position.z += (targetZ - groupRef.current.position.z) * (1 - Math.exp(-delta * 2.8));

    if (orbitAnchorRef.current) {
      orbitAnchorRef.current.rotation.z += (0 - orbitAnchorRef.current.rotation.z) * (1 - Math.exp(-delta * 2.4));
    }
  });

  return (
    <group ref={groupRef} position={[0, 0, 2]} visible={weight > 0.001}>
      <pointLight
        color="#fff7ed"
        intensity={0.45 * weight}
        distance={5}
        decay={2}
        position={[-1.8, 1.7, 2.2]}
      />
      <group ref={orbitAnchorRef}>
        <ProjectCarousel3D
          compact={compact}
          projects={projects}
          rotationProgress={rotationProgress}
          viewport={viewport}
          weight={weight}
        />
      </group>


    </group>
  );
}